import axios from 'axios';
import moment from 'moment';

import { ClienteState, Cliente, Producto, Compra, ProductoPedido } from '@/models/StateDetalle';

const BASE_URL = 'http://localhost:3001/api/public';

const state = () => ({
	cliente: null,
	compras: [],
	comprasHace7Dias: [],
	productosDisponibles: [],
	envaseDisponible: [],
	nuevoPedido: [],
	mostrarFormulario: false,
	fechaActual: '',
	clientesDisponibles: [],
	tiposOperacion: [],
	tipoOperacionSeleccionada: null,
});
const mutations = {
	RESET_STATE(state: ClienteState) {
		state.cliente = null;
		state.compras = [];
		state.comprasHace7Dias = [];
		state.productosDisponibles = [];
		state.nuevoPedido = [];
		state.mostrarFormulario = false;
		state.fechaActual = '';
		state.clientesDisponibles = [];
	},
	SET_TIPO_OPERACION(state, tipo) {
		state.tipoOperacionSeleccionada = tipo;
	},
	SET_TIPOS_OPERACION(state, tipos) {
		state.tiposOperacion = tipos;
	},
	//Este cambia si el formulario se ve o no
	SET_MOSTRAR_FORMULARIO(state: ClienteState, valor: boolean) {
		state.mostrarFormulario = valor;
	},
	//Guarda el cliente
	SET_CLIENTE(state: ClienteState, cliente: Cliente) {
		state.cliente = cliente;
	},
	//G compra realizada
	SET_COMPRAS(state: ClienteState, compras: Compra[]) {
		state.compras = compras;
	},
	//G compra de hace una semana
	SET_COMPRAS_7_DIAS(state: ClienteState, compras: Compra[]) {
		state.comprasHace7Dias = compras;
	},
	//G productos disponibles
	SET_PRODUCTOS(state: ClienteState, productos: Producto[]) {
		state.productosDisponibles = productos;
	},
	//Envase disponible
	SET_ENVASE(state: ClienteState, envase: Producto[]) {
		state.envaseDisponible = envase;
	},
	//G nuevo pedido
	SET_NUEVO_PEDIDO(state: ClienteState, pedido: ProductoPedido[]) {
		state.nuevoPedido = pedido;
	},
	//Agregar fila nueva
	ADD_PRODUCTO(state: ClienteState) {
		state.nuevoPedido.push({ productoId: null, cantidad: 1 });
	},
	//Eliminar fila
	REMOVE_PRODUCTO(state: ClienteState, index: number) {
		state.nuevoPedido.splice(index, 1);
	},
	//Guarda fecha actual que muestro en la vista
	SET_FECHA_ACTUAL(state: ClienteState, fecha: string) {
		state.fechaActual = fecha;
	},
	SET_TODOCLIENTES(state: ClienteState, clientes: Cliente[]) {
		state.clientesDisponibles = clientes;
	},
};
const actions = {
	async obtenerTiposOperacion({ commit }) {
		try {
			const response = await axios.get(`${BASE_URL}/ventas/tipo-operacion`);
			commit('SET_TIPOS_OPERACION', response.data.productos);
		} catch (error) {
			console.error('Error al obtener tipos de operación:', error);
		}
	},
	resetState({ commit }) {
		commit('RESET_STATE');
	},
	async eliminarCompraDelCliente({ state }) {
		const codentiId = state.cliente.id;
		const fecha = state.fechaActual;
		await axios.delete(`${BASE_URL}/ventas/pedido/${codentiId}/${fecha}`);
	},
	setMostrarFormulario({ commit }, valor: boolean) {
		commit('SET_MOSTRAR_FORMULARIO', valor);
	},
	async fetchDetalle({ commit, dispatch }, { id, fecha }) {
		commit('SET_FECHA_ACTUAL', fecha); //Guardo fecha
		try {
			const res = await axios.get(`${BASE_URL}/ventas/products/${id}/${fecha}`);
			commit('SET_CLIENTE', res.data.cliente); //Guardo cliente
			commit('SET_COMPRAS', res.data.compras); //Guardo compras de esa fecha

			if (fecha === moment().format('YYYY-MM-DD')) {
				const hace7Dias = moment().subtract(7, 'days').format('YYYY-MM-DD');
				const antRes = await axios.get(`${BASE_URL}/ventas/products/${id}/${hace7Dias}`);
				commit('SET_COMPRAS_7_DIAS', antRes.data.compras || []);
			}
			await dispatch('fetchProductos');
		} catch (error) {
			console.error('Error al obtener datos del cliente:', error);
		}
	},
	//Traigo los productos
	async fetchProductos({ commit }) {
		try {
			const response = await axios.get(`${BASE_URL}/products`);
			commit('SET_PRODUCTOS', response.data);
		} catch (error) {
			console.error('Error al cargar productos:', error);
		}
	},
	//Traigo los envases
	async fetchEnvases({ commit }) {
		try {
			const response = await axios.get(`${BASE_URL}/products/envase`);
			commit('SET_ENVASE', response.data);
		} catch (error) {
			console.error('Error al cargar productos:', error);
		}
	},
	//Traigo los clientes
	async fetchClientes({ commit }) {
		try {
			const response = await axios.get(`${BASE_URL}/customers`);
			commit('SET_TODOCLIENTES', response.data);
		} catch (error) {
			console.error('Error al cargar productos:', error);
		}
	},
	//Copia las compras de hace 7 dias para repetir pedido
	repetirPedido({ commit, state }) {
		const pedido = state.comprasHace7Dias.map(c => ({
			productoId: c.producto_id,
			cantidad: c.cantidad,
		}));
		commit('SET_NUEVO_PEDIDO', pedido);
		commit('SET_MOSTRAR_FORMULARIO', true);
		commit('SET_COMPRAS_7_DIAS', []);
	},
	//Si va a comprar otra cosa, borro la sugerencia
	descartarSugerencia({ commit }) {
		commit('SET_COMPRAS_7_DIAS', []);
		commit('SET_MOSTRAR_FORMULARIO', true);
	},
	//Agregar fila
	agregarFilaProducto({ commit }) {
		commit('ADD_PRODUCTO');
	},
	//Eliminar fila
	eliminarFila({ commit }, index) {
		commit('REMOVE_PRODUCTO', index);
	},
	resetNuevoPedido({ commit }) {
		commit('SET_NUEVO_PEDIDO', []);
	},
	async guardarPedido({ state, commit, dispatch }) {
		const pedidosValidos = state.nuevoPedido.filter(p => p.productoId && p.cantidad > 0);
		if (!pedidosValidos.length) return;

		try {
			const { cliente, fechaActual, tipoOperacionSeleccionada } = state;

			let importeTotalPedido = 0;

			const renglones = pedidosValidos.map(pedido => {
				const precioUnitario = Number(pedido.precio) || 0;
				const importeTotal = precioUnitario * pedido.cantidad;

				if (precioUnitario === 0) console.warn(`Precio no definido para el producto ${pedido.productoId}`);

				importeTotalPedido += importeTotal;

				return {
					codprodId: pedido.productoId,
					cantidadStock: pedido.cantidad,
					precio_unitario: precioUnitario,
				};
			});

			// Armar la cabecera con el total
			const data = {
				fecha: fechaActual,
				codentiId: Number(cliente.id),
				tipoOperacion: tipoOperacionSeleccionada || '',
				importe_total: importeTotalPedido,
				renglones,
			};

			console.log('Pedido completo:', data);

			await axios.post(`${BASE_URL}/ventas/pedido`, data);

			commit('SET_MOSTRAR_FORMULARIO', false);
			commit('SET_NUEVO_PEDIDO', []);
			dispatch('fetchDetalle', { id: cliente.id, fecha: fechaActual });

			return true;
		} catch (error) {
			console.error('Error al guardar pedido:', error);
			throw error;
		}
	},
	async crearCliente({ commit }, nuevoCliente: Cliente) {
		try {
			const res = await axios.post(`${BASE_URL}/customers`, nuevoCliente);
			return res.data;
		} catch (error) {
			console.error('Error al crear cliente:', error);
			throw error;
		}
	},
	async guardarEnvases({ state, dispatch }, envases) {
		if (!envases.length) return;

		const { cliente, fechaActual } = state;
		if (!cliente || !fechaActual) throw new Error('Faltan datos');

		try {
			const renglones = envases.map(envase => ({
				codprodId: Number(envase.productoId),
				cantidadStock: Number(envase.cantidad),
				precio_unitario: 0,
			}));

			const data = {
				fecha: fechaActual,
				codentiId: Number(cliente.id),
				tipoOperacion: '',
				importe_total: 0,
				renglones,
			};

			console.log('Enviando envases como pedido:', data);

			await axios.post(`${BASE_URL}/ventas/pedido`, data);

			dispatch('fetchDetalle', { id: cliente.id, fecha: fechaActual });
			return true;
		} catch (error) {
			console.error('Error al guardar envases:', error);
			throw error;
		}
	},
};
const getters = {
	tipoOperacionSeleccionada: state => state.tipoOperacionSeleccionada,
	cliente: (state: ClienteState) => state.cliente,
	compras: (state: ClienteState) => state.compras,
	comprasHace7Dias: (state: ClienteState) => state.comprasHace7Dias,
	productosDisponibles: (state: ClienteState) => state.productosDisponibles,
	envaseDisponible: (state: ClienteState) => state.envaseDisponible,
	nuevoPedido: (state: ClienteState) => state.nuevoPedido,
	mostrarFormulario: (state: ClienteState) => state.mostrarFormulario,
	fechaActual: (state: ClienteState) => state.fechaActual,
	clientesDisponibles: (state: ClienteState) => state.clientesDisponibles,
	pedidoValido: (state: ClienteState) => {
		return state.nuevoPedido.length > 0 && state.nuevoPedido.every(p => p.productoId && p.cantidad > 0);
	},
	tiposOperacion: state => state.tiposOperacion,
};
export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
